import {Injectable} from '@angular/core';

import {AuthenticationService} from './index';
import {LoginHelper} from '../helpers';
import {BehaviorSubject, Subject, tap} from "rxjs";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class CveService {
  constructor(public http: HttpClient,
              public config: IndexConfigService) {
  }

  public url(method: string, id: number = undefined, submethod: string = undefined) {
    let url = this.config.api + '/api/' + method;
    if (id) url += '/' + id;
    if (submethod) url += '/' + submethod;
    return url;
  }

  @Load()
  getCveItems() {
    return this.http.get<any>(this.url('cve'));
  }

  @Load()
  updateCve() {
    return this.http.post(this.url('cve'), {});
  }
}
